import SelectedReference from "./SelectedReference";

function SelectedReferenceWrapper({
  record,
  field,
  onView,
  onRemove,
  setKeepOpen,
  modulesMap,
}) {
  let subitemRecordNameField = null;
  let key = record?.id;

  return (
    <SelectedReference
      key={key}
      record={record}
      field={field}
      onView={onView}
      onRemove={() => onRemove(record)}
      setKeepOpen={setKeepOpen}
      modulesMap={modulesMap}
    />
  );
}

const SelectedReferences = ({
  field,
  selected,
  setSelected,
  onView,
  setKeepOpen,
  modulesMap,
}) => {
  const isSingleRef = field?.FieldType === "SingleReference";

  const EmptyState = () => (
    <h5 className="p-2 m-0 font-weight-normal">Add {field?.Name}</h5>
  );

  if (isSingleRef) {
    if (!selected) return <EmptyState />;

    return (
      <SelectedReferenceWrapper
        record={selected}
        field={field}
        onView={onView}
        onRemove={onRemove}
        setKeepOpen={setKeepOpen}
        modulesMap={modulesMap}
        noBorder={true}
      />
    );
  }

  if (!selected || selected?.length === 0) {
    return <EmptyState />;
  }

  return (
    Array.isArray(selected) &&
    selected.map((record, i) => {
      return (
        <SelectedReferenceWrapper
          key={i}
          record={record}
          field={field}
          onView={onView}
          onRemove={onRemove}
          setKeepOpen={setKeepOpen}
          modulesMap={modulesMap}
          noBorder={i === selected?.length - 1}
        />
      );
    })
  );

  function onRemove(value) {
    if (isSingleRef) {
      return setSelected(null);
    }

    const isSubitem = value?._isSubitem;

    // Handle Multi Reference
    setSelected((prev) =>
      prev.filter((r) => {
        if (isSubitem) {
          return r?._SubitemID !== value?._SubitemID;
        }

        if (r?._isSubitem) {
          return true;
        }

        return r?.id !== value?.id;
      })
    );
  }
};

export default SelectedReferences;
